function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import * as Sentry from '@sentry/react';
import { Suspense, useEffect } from 'react';
import { Outlet } from 'react-router';
import { HubErrorBoundary } from '@arc/frontend/ui-common';
import { LoadingIndicator } from '@arc/frontend/ui-graphics';
import { theme } from '@arc/frontend/ui-theme';
import { AbilityProvider, IdleTimeout, useRefreshUser, useSavedLocation } from '@arc/frontend/util-auth';
import { useWebsocketListener, useWebsockets } from '@arc/frontend/util-websockets';
import { ServerToClientEvents } from '@arc/shared/util-websockets';
import { Header } from './Header/Header';
import { RequireLogin } from './Login/RequireLogin';
const styles = {
  app: /*#__PURE__*/css({
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    gridTemplateColumns: '100%',
    gridTemplateAreas: "'header' 'main'",
    backgroundColor: theme.colors.background.default
  }, process.env.NODE_ENV === "production" ? "" : ";label:app;"),
  header: process.env.NODE_ENV === "production" ? {
    name: "1hk3dg8",
    styles: "grid-area:header"
  } : {
    name: "94830y-header",
    styles: "grid-area:header;label:header;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  mainContainer: process.env.NODE_ENV === "production" ? {
    name: "122vymx",
    styles: "grid-area:main;overflow:hidden;height:100%"
  } : {
    name: "1b44237-mainContainer",
    styles: "grid-area:main;overflow:hidden;height:100%;label:mainContainer;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
function SessionListener() {
  const refreshUser = useRefreshUser();
  useWebsocketListener(ServerToClientEvents.SessionMutated, () => {
    void refreshUser();
  });
  return null;
}
function WSKeeper() {
  const wsClient = useWebsockets();
  useEffect(() => {
    // ensure we are connected to the WS client
    wsClient?.connect();
  }, [wsClient]);
  return null;
}
function App() {
  useSavedLocation();
  return <RequireLogin>
			<AbilityProvider>
				<IdleTimeout />
				<div css={styles.app}>
					<Header outerStyle={styles.header} />
					<div css={styles.mainContainer}>
						<HubErrorBoundary>
							<Suspense fallback={<LoadingIndicator />}>
								<Outlet />
							</Suspense>
						</HubErrorBoundary>
					</div>
				</div>
				<SessionListener />
				<WSKeeper />
			</AbilityProvider>
		</RequireLogin>;
}
export default Sentry.withProfiler(App);